export function getGraphqlBase(host: string, apiPrefix = "") {
    // "/graphql/" path suffix style
    return `${host}${apiPrefix}/graphql/`;
}

export function isNumericIp(ip: string) {
    // Check both IPv4 and IPv6, maybe optional [] in IPv6
    return /^\d+(\.\d+){0,3}$/.test(ip) || /^\[?[0-9a-fA-F:]+\]?$/.test(ip);
}

export function domainMatches(host: string, domain: string) {
    return host === domain || host.endsWith(`.${domain}`);
}
